// Import files here. This is the main lib entry point.
// You can use ES5, or ES6 here.
import $ from "jquery";
const jQuery = $;

$(document).on("click", 'a[rel$="external"]', function () {
    $(this).attr("target", "_blank");
});

$(document).on("click", 'a[href$=".pdf"]', function () {
    $(this).attr("target", "_blank");
});

$("a").each(function () {
    var a = new RegExp("/" + window.location.host + "/");
    if (!a.test(this.href)) {
        $(this).click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            window.open(this.href, "_blank");
        });
    }
});

jQuery.fn.extend({
    live: function (event, callback) {
        if (this.selector) {
            jQuery(document).on(event, this.selector, callback);
        }
    },
});

$(".nav-links").click(function (e) {
    anchorScroll(
        $(this),
        $($(this).attr("href")),
        1200,
        $("#header").get(0).getBoundingClientRect().height
    );
});

function anchorScroll(this_obj, that_obj, base_speed, offset) {
    var this_offset = this_obj.offset();
    var that_offset = that_obj.offset();
    var offset_diff = Math.abs(that_offset.top - this_offset.top);

    var speed = (offset_diff * base_speed) / 2000;

    $("html,body").animate(
        {
            scrollTop: that_offset.top - offset,
        },
        speed
    );
}

$('[data-element-name="content"] img.remdiv').unwrap("p");

//DISALBES form submit on enter
$("#searchform").on("keyup keypress", function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        e.preventDefault();
        return false;
    }
});

//adds new window label for screen readers

$("a[target='_blank']").each(function (e) {
    var el = $(this);
    if (el.text() !== "") {
        el.attr("aria-label", el.text() + " - New Window");
    }
});

$("p").each(function () {
    var $this = $(this);
    if ($this.html().replace(/\s|&nbsp;/g, "").length == 0) $this.remove();
});

$(document).ready(function () {
    $("#bs4navbar .nav-link").click(function (e) {
        if (!!e.originalEvent) {
            if (e.originalEvent instanceof MouseEvent) {
                var url = $(this).attr("href");
                $(location).attr("href", url);
            }
        }
    });
});



$(document).ready(() => {
    // do the image transitions
     var switchTimeSeconds = 4;
     const images = [
        '/wp-content/uploads/2021/03/ym_estate_3_generation_women.jpg',
        '/wp-content/uploads/2021/03/ym_estate_whole_family.jpg',
     ];
     let idx = 1;

     setInterval(() => {
         $('body.home').css('background-image', `url(${images[idx]})`);
        idx = (idx + 1) % images.length;
     }, switchTimeSeconds * 1000);
 })
